import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchTargetIndustries() {
  return axios.get(apiUrl.targetIndustries.GET.LIST);
}

export function sendContactEmail(params) {
  return axios.post(apiUrl.contactUs.POST, params);
}

export function sendSlackMessage({ message, url, backendResponse = null }) {
  return axios.post(apiUrl.sendSlackMessage.POST, { message, url, backendResponse });
}
